import React from 'react';
import { styled } from '@compiled/react';
import { PURPLE, type Color } from '@atlassian/jira-issue-epic-color/src/common/types.tsx';
import { dependencyThemes } from '../../../../common/utils/dependency-themes.tsx';
import { Icon } from './icon/index.tsx';
import type { DependencyLinePreviewProps } from './types.tsx';

export const DependencyLinePreview = ({
	x0,
	y0,
	x,
	y,
	width,
	height,
	color,
}: DependencyLinePreviewProps) => {
	const theme = dependencyThemes[color];
	const top = y - 5;
	const left = x - 5;

	return (
		<>
			<Icon color={theme.icon} top={top} left={left} />
			<svg width={width} height={height}>
				{/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */}
				<Line x1={x0} y1={y0} x2={left} y2={top} color={theme.line as Color} />
			</svg>
		</>
	);
};

DependencyLinePreview.defaultProps = {
	// We are mapping Color to design tokens in transformColorToTheme
	color: PURPLE,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Line = styled.line<{ color: Color }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	stroke: ({ color }) => color,
	strokeWidth: 2,
	strokeLinecap: 'round',
	fill: 'none',
});
